import {Col, Row, Button, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import UserForm from "../form/userForm";
import LogoutButton from "../layout/logoutButton";
import {useLocation, useNavigate} from "react-router-dom";
import ApiService from "../../services/ApiService";
import GenericErrorModal from "../modal/genericErrorModal";

const Edit = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [title, setTitle] = useState();
    const [name, setName] = useState();
    const [surname, setSurname] = useState();
    // eslint-disable-next-line no-unused-vars
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [checkPassword, setCheckPassword] = useState();

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(()=> {
        ApiService.getUserInfoFromId().then(userinfo => {
            setName(userinfo.firstName)
            setSurname(userinfo.lastName)
            setTitle(userinfo.title)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSalvaEChiudi = (e) => {
        e.preventDefault();

        if (title && name && surname && password && checkPassword && (password === checkPassword)) {
            let requestParams = {
                title: title,
                email: location.state?.email,
                firstName: name,
                lastName: surname,
                password: password,
            }

            ApiService.editDatiProfilo(requestParams).then((response) => {
                setErrorModal({
                    state: true,
                    title: "Aggiornamento completato",
                    body: "Ok"
                })
                navigate(-1)
            })
                .catch(error => {
                    setErrorModal({
                        state: true,
                        title: "Errore nell'aggiornamento",
                        body: "Ok"
                    })
                })
        }

    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Informazioni profilo</h2>
                        </Col>
                    </Row>

                    <Row className={'my-4'}>
                        <Col xs={12}>
                            <Form>
                                <UserForm setTitle={setTitle} title={title} setName={setName} name={name} setSurname={setSurname} surname={surname}
                                          setPassword={setPassword} setCheckPassword={setCheckPassword}
                                          setEmail={setEmail} editMode={true}/>
                                <p className={'mt-1'}>*campi obbligatori</p>

                                <div className={'d-flex flex-column justify-content-end align-items-end'}>
                                    <Button variant={'primary'}
                                            disabled={(title === undefined || name === undefined || surname === undefined || password === undefined || checkPassword === undefined)}
                                            className={'px-4 fw-bold'} onClick={(e) => handleSalvaEChiudi(e)}>Salva e
                                        chiudi</Button>
                                    <Button variant={'link'} onClick={() => navigate(-1)} className={'p-0 mt-2'}>Annulla modifiche</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Col>

                <Col>
                    <div className={'w-100 mt-4 mt-lg-0 d-flex justify-content-end'}>
                        <LogoutButton/>
                    </div>
                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default Edit;
